export default defineNuxtRouteMiddleware((to: any, from: any) => {
  const { getCartStatus } = useCart();
  const cartStore = useCartStore();
  const cart = computed(() => cartStore.cart);

  if (cart.value) {
    const cartStatus = computed(() => getCartStatus(cart.value));
    if (cartStatus.value !== 'ON_GOING' && !to.path.includes('/quotes')) {
      return navigateTo('/');
    }
  }
});
